import * as $ from 'jquery';

import { LessonTimer, TimerDoneCallback } from './lessontimer';
import { MemberLesson } from "./memberlesson";

export class MemberTimers {
    lessontimer: LessonTimer;
    maxtimer: LessonTimer;
    securityquestionstimer: LessonTimer;
    breaktimer: LessonTimer;
    readonly lesson: MemberLesson;
    $divTimersPopup: JQuery;

    constructor(lesson: MemberLesson) {
        this.lesson = lesson;
    }

    init() {
        $(document).on('keypress', function (e) {
            if (e.which === 84) { // T
                $('#timers-popup').toggle();
            }
        });

        this.setupPrimary();
        this.setupMax();
        this.setupBreak();
        this.setupSecurityQuestion();
        this.setupTexasAmi();
    }

    setupPrimary(): boolean {
        const seconds = this.lesson.lessonSetup.timerSeconds;

        const self = this;
        if (seconds > 0) {
            this.lessontimer = new LessonTimer(seconds, 'lessontimer', () => self.lesson.timerDone());
            this.lessontimer.start();
            const lessontimertop = new LessonTimer(seconds, 'lessontimertop', null);
            lessontimertop.start();
            const lessontimerwarning = new LessonTimer(seconds, 'lessontimerwarning', null);
            lessontimerwarning.start();
            const $warning = $('#lessontimerwarning');
            (<any>$warning).countdown('option', 'layout', '{h<}{hn} {hl}{h>} {m<}{mn} {ml}{m>} {s<}{sn} {sl}{s>}');
            (<any>$warning).countdown('option', 'format', 'hMS');
            (<any>$warning).countdown('option', 'compact', false);

            return true;
        }
        else {
            $('#lessontimerarea, #lessontimerrequiredarea').hide();
            if (self.lesson.timerDone) {
                self.lesson.timerDone();
            }
            return false;
        }
    }

    setupMax(): boolean {
        const self = this;
        const seconds = this.lesson.lessonSetup.maxTimerSeconds;
        if (seconds > 0) {
            this.maxtimer = new LessonTimer(seconds, 'maxtimer', ()=>self.lesson.timerDoneMax());
            this.maxtimer.start();
            return true;
        } else {
            $('#maxtimerarea').hide();
            return false;
        }
    }

    setupSecurityQuestion(): boolean {
        const self = this;
        const seconds = this.lesson.lessonSetup.securityQuestionsTimerSeconds;
        if (seconds > 0) {
            this.securityquestionstimer = new LessonTimer(seconds, 'securityquestionstimer',
                ()=>self.lesson.timerDoneSecurityQuestions());
            this.securityquestionstimer.start();
            return true;
        }
        else {
            return false;
        }
    }

    setupBreak(): boolean {
        const seconds = this.lesson.lessonSetup.breakTimerSeconds;
        const self = this;
        if (seconds > 0) {
            this.breaktimer = new LessonTimer(seconds, 'breaktimer', ()=>self.lesson.timerDoneBreak());
            this.breaktimer.start();
            return true;
        }
        else {
            return false;
        }
    }

    setupTexasAmi() {
        const self = this;
        const amims = this.lesson.lessonSetup.texasAmiSeconds;
        if (amims > 0) {
            setInterval(function () {
                const url = "/Services/AmiTimer.ashx?ms=" + amims + "&pid=" +
                    self.lesson.lessonSetup.purchaseItemID + "&slid=" + self.lesson.lessonSetup.schoolLessonID;
                $.post(url, function (data) {

                });
            }, amims);
        }
    }

    setupDebugTimerPopup() {
        this.$divTimersPopup = $('#timers-popup');
        const self = this;
        setInterval(() => self.updateDebugTimerPopup(), 1000);
    }

    updateDebugTimerPopup() {
        if (!this.$divTimersPopup.is(':visible')) {
            return;
        }
        if (this.lessontimer) {
            this.lessontimer.formatElement(this.$divTimersPopup.find('dd:eq(0)'));
        }
        if (this.maxtimer) {
            this.maxtimer.formatElement(this.$divTimersPopup.find('dd:eq(1)'));
        }
        if (this.breaktimer) {
            this.breaktimer.formatElement(this.$divTimersPopup.find('dd:eq(3)'));
        }
        if (this.securityquestionstimer) {
            this.securityquestionstimer.formatElement(this.$divTimersPopup.find('dd:eq(4)'));
        }
    }
}
